  <div class="bmc-authentication-detail bmc-authentication-detail__placeholder" *ngIf="!selectedOption">
    <p class="bmc-authentication-detail__placeholder__text">
      {{ 'AUTHENTICATION.SELECT_A_COMPONENT_FROM_LIST' | translate }}</p>
  </div>
  <div class="bmc-authentication-detail" *ngIf="selectedOption">
    <label
      class="bmc-authentication-detail__title">{{'AUTHENTICATION.OPTIONS_' + (selectedOption.key || selectedOption.name) | translate}}</label>
    <div class="bmc-authentication-detail__container" >
      <label class="bmc-authentication-detail__label">{{ "GLOBAL.DESCRIPTION" | translate }}</label>
      <p>{{'AUTHENTICATION.OPTIONS_DESC_' + (selectedOption.key || selectedOption.name) | translate}}</p>
      <label class="bmc-authentication-detail__label">{{ "GLOBAL.VALUE" | translate }}</label>
      <form #form="ngForm">
        <bzg-input name="text" *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'text'"
          type="text" [(ngModel)]="currentValue" [disabled]="!isEditable || isDisabled"></bzg-input>
        <bzg-input #numberInput name="number" *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'number'"
        type="number" [(ngModel)]="currentValue" (keypress)="utilsService.onlyNumbers($event)"
          [disabled]="!isEditable || isDisabled"
          [max]="selectedMetadata[(selectedOption.key || selectedOption.name)].max === -1 ? undefined : selectedMetadata[(selectedOption.key || selectedOption.name)].max"
          [min]="selectedMetadata[(selectedOption.key || selectedOption.name)]?.min">
          <bzg-min-error>{{ 'GLOBAL.INVALID_MIN_VALUE' | translate }} {{selectedMetadata[(selectedOption.key || selectedOption.name)].min}}</bzg-min-error>
          <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate }} {{selectedMetadata[(selectedOption.key || selectedOption.name)].max}}</bzg-max-error>
        </bzg-input>
        <bzg-password name="password"
          *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'password'"
          [(ngModel)]="currentValue" [maxlength]="selectedMetadata[(selectedOption.key || selectedOption.name)].max"
          [disabled]="!isEditable || isDisabled">
        </bzg-password>
        <bzg-input name="email" *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'email'"
          type="email" [(ngModel)]="currentValue" [disabled]="!isEditable || isDisabled">
        </bzg-input>
        <textarea name="large-text"
          *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'text-large'" rows="8"
          class="bmc-authentication-detail__textarea" [(ngModel)]="currentValue" [disabled]="!isEditable || isDisabled">
        </textarea>

        <bzg-switch name="boolean"
          *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'boolean'"
          (change)="setCurrentBooleanValue($event)" [checked]="currentValue === 'True'" [disabled]="!isEditable || isDisabled">
        </bzg-switch>

        <bzg-select name="list" *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'list'"
          [(value)]="currentValue" [disabled]="!isEditable || isDisabled">
          <bzg-option
            *ngFor="let item of selectedMetadata[(selectedOption.key || selectedOption.name)].options | keyvalue"
            [value]="item.key">
            {{item.value}}
          </bzg-option>
        </bzg-select>
        <p *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'file'">{{currentFileName}}</p>
        <bzg-button-primary [disabled]="!isEditable || status=='begin' || isDisabled" (click)="uploadFile()"
          *ngIf="selectedMetadata[(selectedOption.key || selectedOption.name)].type === 'file'">
          <svg class="bz-icon-svg bz-icon-svg--16">
            <use xlink:href="#icon-upload"></use>
          </svg>
          {{ 'AUTHENTICATION.BUTTON_BROWSE' | translate }}
        </bzg-button-primary>
        <input #file type="file" style="display: none" type="file" [accept]="currentAllowedExtensions"
          (change)="readFile($event.target)">
        <div class="bmc-authentication-detail__apply-button">
          <bzg-button-primary
            (click)="updateData(selectedOption, currentValue, !!selectedOption.name, fileNameProperty, currentFileName)"
            [disabled]="!isEditable || isDisabled || !isFormValid()">
            {{ "GLOBAL.APPLY" | translate }}
          </bzg-button-primary>
        </div>
      </form>
    </div>
  </div>

